import { render, staticRenderFns } from "./AlertaProcessamento.vue?vue&type=template&id=fb03ea0a&scoped=true"
import script from "./AlertaProcessamento.vue?vue&type=script&lang=js"
export * from "./AlertaProcessamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb03ea0a",
  null
  
)

export default component.exports